/* SanaStyle — interacciones propias (prefijo ss-) */
(function () {
  var reducir = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Entradas al hacer scroll ---------- */
  var observador = null;
  function initReveal(raiz) {
    var els = (raiz || document).querySelectorAll('.ss-reveal:not(.ss-visible)');
    if (!els.length) return;
    if (reducir || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('ss-visible'); });
      return;
    }
    if (!observador) {
      observador = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('ss-visible');
            observador.unobserve(e.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    }
    els.forEach(function (el) { observador.observe(el); });
  }

  /* ---------- Parallax suave del hero ---------- */
  function initParallax() {
    var imgs = document.querySelectorAll('[data-ss-parallax]');
    if (!imgs.length || reducir) return;
    var pendiente = false;
    function pintar() {
      imgs.forEach(function (img) {
        var fuerza = parseFloat(img.getAttribute('data-ss-parallax')) || 0;
        var r = img.parentElement.getBoundingClientRect();
        var progreso = (r.top + r.height / 2 - window.innerHeight / 2) / window.innerHeight;
        img.style.transform = 'translate3d(0,' + (progreso * fuerza * -1).toFixed(1) + 'px,0)';
      });
      pendiente = false;
    }
    window.addEventListener('scroll', function () {
      if (!pendiente) { pendiente = true; requestAnimationFrame(pintar); }
    }, { passive: true });
    pintar();
  }

  /* ---------- Galería de producto ---------- */
  function initGaleria(raiz) {
    (raiz || document).querySelectorAll('[data-ss-galeria]').forEach(function (gal) {
      var grandes = gal.querySelectorAll('.ss-galeria__principal img');
      var minis = gal.querySelectorAll('.ss-galeria__miniaturas button');
      if (!grandes.length) return;
      var actual = 0;
      function ir(i) {
        actual = (i + grandes.length) % grandes.length;
        grandes.forEach(function (g, n) { g.classList.toggle('ss-activa', n === actual); });
        minis.forEach(function (m, n) {
          m.classList.toggle('ss-activa', n === actual);
          if (n === actual && m.scrollIntoView) m.parentElement.scrollTo({ left: m.offsetLeft - 20, behavior: 'smooth' });
        });
      }
      minis.forEach(function (m, n) { m.addEventListener('click', function () { ir(n); }); });
      var prev = gal.querySelector('.ss-galeria__flecha--prev');
      var next = gal.querySelector('.ss-galeria__flecha--next');
      if (prev) prev.addEventListener('click', function () { ir(actual - 1); });
      if (next) next.addEventListener('click', function () { ir(actual + 1); });
      /* deslizar con el dedo */
      var x0 = null;
      var principal = gal.querySelector('.ss-galeria__principal');
      principal.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      principal.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) ir(actual + (dx < 0 ? 1 : -1));
        x0 = null;
      });
      gal.ssIr = function (mediaId) {
        grandes.forEach(function (g, n) { if (g.getAttribute('data-media-id') === String(mediaId)) ir(n); });
      };
    });
  }

  /* ---------- Cantidad ---------- */
  function initCantidad(raiz) {
    (raiz || document).querySelectorAll('.ss-cantidad').forEach(function (c) {
      var input = c.querySelector('input');
      c.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(input.value, 10) || 1;
          v += b.getAttribute('data-paso') === '+' ? 1 : -1;
          input.value = Math.max(1, v);
        });
      });
    });
  }

  /* ---------- Variantes ---------- */
  function formatoDinero(centimos) {
    var formato = window.ssFormatoDinero ||'{{amount_with_comma_separator}} €';
    var valor = (centimos / 100).toFixed(2);
    var conComa = valor.replace('.', ',');
    return formato
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, conComa)
      .replace(/\{\{\s*amount\s*\}\}/, valor)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(centimos / 100))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, Math.round(centimos / 100));
  }
  function initVariantes(raiz) {
    (raiz || document).querySelectorAll('[data-ss-producto]').forEach(function (prod) {
      var datos = prod.querySelector('[data-ss-variantes]');
      var selector = prod.querySelector('.ss-variantes');
      if (!datos || !selector) return;
      var variantes = JSON.parse(datos.textContent);
      selector.addEventListener('change', function () {
        var elegidas = [];
        selector.querySelectorAll('fieldset').forEach(function (fs) {
          var c = fs.querySelector('input:checked');
          elegidas.push(c ? c.value : null);
        });
        var v = variantes.find(function (vr) {
          return vr.options.every(function (o, i) { return o === elegidas[i]; });
        });
        var boton = prod.querySelector('[data-ss-boton]');
        var botonYa = prod.querySelector('[data-ss-boton-ya]');
        if (!v) {
          if (boton) { boton.disabled = true; boton.querySelector('span').textContent = boton.getAttribute('data-txt-nodisp'); }
          if (botonYa) botonYa.disabled = true;
          return;
        }
        prod.querySelectorAll('input[name="id"]').forEach(function (i) { i.value = v.id; });
        prod.querySelectorAll('[data-ss-precio]').forEach(function (p) { p.textContent = formatoDinero(v.price); });
        prod.querySelectorAll('[data-ss-precio-antes]').forEach(function (p) {
          if (v.compare_at_price && v.compare_at_price > v.price) { p.textContent = formatoDinero(v.compare_at_price); p.hidden = false; }
          else { p.hidden = true; }
        });
        if (boton) {
          boton.disabled = !v.available;
          boton.querySelector('span').textContent = v.available ? boton.getAttribute('data-txt') : boton.getAttribute('data-txt-agotado');
        }
        if (botonYa) botonYa.disabled = !v.available;
        if (v.featured_media) {
          var gal = prod.querySelector('[data-ss-galeria]');
          if (gal && gal.ssIr) gal.ssIr(v.featured_media.id);
        }
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
      });
    });
  }

  /* ---------- Añadir al carrito (abre el carrito lateral de Dawn) ---------- */
  function initFormularios(raiz) {
    (raiz || document).querySelectorAll('form.ss-form').forEach(function (form) {
      if (form.ssListo) return;
      form.ssListo = true;
      form.addEventListener('submit', function (e) {
        var envio = e.submitter;
        if (envio && envio.hasAttribute('data-ss-boton-ya')) return; /* "Comprar ya": envío normal al pago */
        var cajon = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        if (!cajon || typeof cajon.renderContents !== 'function' || !window.routes) return;
        e.preventDefault();
        var boton = form.querySelector('[data-ss-boton]');
        var error = form.querySelector('.ss-form-error');
        if (boton) { boton.setAttribute('aria-busy', 'true'); boton.disabled = true; }
        if (error) error.textContent = '';
        var fd = new FormData(form);
        fd.append('sections', cajon.getSectionsToRender().map(function (s) { return s.id; }));
        fd.append('sections_url', window.location.pathname);
        if (cajon.setActiveElement) cajon.setActiveElement(document.activeElement);
        fetch(window.routes.cart_add_url, {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
          body: fd
        })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (res.status) {
              if (error) error.textContent = res.description || res.message || 'No se pudo añadir.';
              return;
            }
            if (cajon.classList.contains('is-empty')) cajon.classList.remove('is-empty');
            cajon.renderContents(res);
          })
          .catch(function () { form.submit(); })
          .finally(function () {
            if (boton) { boton.removeAttribute('aria-busy'); boton.disabled = false; }
          });
      });
    });
  }

  /* ---------- Barra fija de compra en móvil ---------- */
  function initBarraFija() {
    var barra = document.querySelector('.ss-barra-fija');
    var objetivo = document.querySelector('[data-ss-boton]');
    if (!barra || !objetivo || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (e) {
      var r = e[0].boundingClientRect;
      barra.classList.toggle('ss-mostrar', !e[0].isIntersecting && r.top < 0);
    }).observe(objetivo);
    var b = barra.querySelector('button');
    if (b) b.addEventListener('click', function () { objetivo.click(); });
  }

  function iniciar(raiz) {
    initReveal(raiz);
    initGaleria(raiz);
    initCantidad(raiz);
    initVariantes(raiz);
    initFormularios(raiz);
  }

  document.addEventListener('DOMContentLoaded', function () {
    iniciar(document);
    initParallax();
    initBarraFija();
  });
  /* Editor de Shopify: re-iniciar al cambiar una sección */
  document.addEventListener('shopify:section:load', function (e) { iniciar(e.target); });
})();
